export const calculateSmsUsage = (message, isMMS = false) => {
    if (isMMS) {
        return { encoding: 'MMS', characters: [...message].length, segments: 1, credits: 4, note: 'MMS (no character limit)' };
    }
    // GSM 7-bit basic charset (ESC, 0x1B, expressed via fromCharCode to avoid ambiguous escaping)
    const gsm7basic =
        '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ' + String.fromCharCode(27) + 'ÆæßÉ ' +
        "!\"#¤%&'()*+,-./" +
        "0123456789" +
        ":;<=>?" +
        "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§" +
        "¿abcdefghijklmnopqrstuvwxyzäöñüà";

    // GSM 7-bit extended chars (count as 2)
    const gsm7ext = "^{}\\[~]|€";

    let encoding = 'GSM-7';
    let gsmLength = 0;

    // Iterate safely over Unicode characters
    for (const char of message) {
        if (gsm7basic.includes(char)) {
            gsmLength += 1;
        } else if (gsm7ext.includes(char)) {
            gsmLength += 2;
        } else {
            encoding = 'UCS-2';
            break;
        }
    }

    // Unicode handling
    if (encoding === 'UCS-2') {
        const charCount = [...message].length;

        if (charCount <= 70) {
            return {
                encoding: 'UCS-2',
                characters: charCount,
                per_segment_limit: 70,
                segments: 1,
                credits: 1,
                note: 'Single-part Unicode SMS'
            };
        }

        const segments = Math.ceil(charCount / 67);

        return {
            encoding: 'UCS-2',
            characters: charCount,
            per_segment_limit: 67,
            segments,
            credits: segments,
            note: 'Multi-part Unicode SMS'
        };
    }

    // GSM-7 handling
    if (gsmLength <= 160) {
        return {
            encoding: 'GSM-7',
            characters: gsmLength,
            per_segment_limit: 160,
            segments: 1,
            credits: 1,
            note: 'Single-part GSM SMS'
        };
    }

    const segments = Math.ceil(gsmLength / 153);

    return {
        encoding: 'GSM-7',
        characters: gsmLength,
        per_segment_limit: 153,
        segments,
        credits: segments
    };
}
